const View = require("presto-ui").baseView;
const dom = require("presto-ui").doms;

const LinearLayout = require("presto-ui").views.LinearLayout;
const ImageView = require("presto-ui").views.ImageView;
const TextView = require("presto-ui").views.TextView;
const EditText = require("presto-ui").views.EditText;

const Config = require('./../../globalConfig');
const Controller = require('./../../controller/pages/Main/Presto');
const Strings = require('./../../res/string');
const Accessibility = require('./../../res/accessibility');
const Font = require('./../../res/fontStyle');
const Color = require('./../../res/color');
const FontSize = require('./../../res/fontSize');
const FontColor = require('./../../res/fontColor');

class Presto extends Controller {

	constructor(props, children, state) {
		super(props, children, state);
		this.STR = Strings();
		this.HINT = Accessibility();
	}

	onPop = () => {}

	render = () => {
		this.layout = (
			<LinearLayout
				id={this.id("Content")}
				height="match_parent"
				width="match_parent"
				orientation="vertical"
				gravity="center_horizontal"
				padding="0,0,0,33"
				background={Color.A__FFFFFFFF}
				cornerRadius="0"
				root={true}
				style={this.style_Content}>
				<LinearLayout
					id={this.id("Header_Presto")}
					height="99"
					width="match_parent"
					orientation="horizontal"
					padding="80,32,85,31"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_Header_Presto}>
					<ImageView
						id={this.id("Group_5")}
						height="36"
						width="301"
						imageUrl="group536"
						style={this.style_Group_5} />
					<LinearLayout
						id={this.id("Space700000000ø")}
						weight="1"
						style={this.style_Space700000000ø} />
					<TextView
						id={this.id("Forum")}
						height="25"
						width="53"
						margin="0,5,0,0"
						text={this.STR.Forum2}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.AVENIR_ROMAN}
						gravity="left"
						style={this.style_Forum} />
				</LinearLayout>
				<LinearLayout
					id={this.id("Hero_text")}
					height="500"
					width="match_parent"
					orientation="vertical"
					gravity="center_horizontal"
					padding="0,0,0,72"
					margin="0,54,0,0"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_Hero_text}>
					<TextView
						id={this.id("Title")}
						height="64"
						width="match_parent"
						text={this.STR.Presto_21}
						textSize={FontSize.A_60}
						color={FontColor.A__FFFF0000}
						fontStyle={Font.AVENIR_BLACK}
						lineHeight="64px"
						gravity="center"
						style={this.style_Title} />
					<TextView
						id={this.id("Pure_functional_appl")}
						height="49"
						width="match_parent"
						margin="0,20,0,0"
						text={this.STR.Pure_functional_appl48}
						textSize={FontSize.A_36}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						gravity="center"
						style={this.style_Pure_functional_appl} />
					<LinearLayout
						id={this.id("Space800000000ø")}
						weight="1"
						style={this.style_Space800000000ø} />
					<ImageView
						id={this.id("Hero_Image")}
						height="230"
						width="304"
						imageUrl="heroimage35"
						style={this.style_Hero_Image} />
				</LinearLayout>
				<LinearLayout
					id={this.id("Presto_flow")}
					height="402"
					width="match_parent"
					orientation="vertical"
					padding="80,0,80,0"
					margin="0,47,0,0"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_Presto_flow}>
					<LinearLayout
						id={this.id("Line")}
						height="2"
						width="250"
						background={Color.A__FFD7D7D7}
						stroke="3,#ff0000"
						cornerRadius="0"
						style={this.style_Line} />
					<LinearLayout
						id={this.id("CodebusinessGithubmarkpr")}
						height="370"
						width="match_parent"
						orientation="horizontal"
						margin="0,30,0,0"
						style={this.style_CodebusinessGithubmarkpr}>
						<LinearLayout
							id={this.id("GithubmarkPr")}
							height="171"
							width="300"
							orientation="vertical"
							cornerRadius="0"
							style={this.style_GithubmarkPr}>
							<TextView
								id={this.id("Presto_Flow")}
								height="50"
								width="match_parent"
								text={this.STR.Presto_Flow49}
								textSize={FontSize.A_40}
								color={FontColor.A__FF000000}
								fontStyle={Font.AVENIR_BLACK}
								lineHeight="42px"
								gravity="left"
								style={this.style_Presto_Flow} />
							<LinearLayout
								id={this.id("Group7Quickstart")}
								height="31"
								width="185"
								orientation="horizontal"
								margin="0,30,0,0"
								style={this.style_Group7Quickstart}>
								<ImageView
									id={this.id("Group_7")}
									height="31"
									width="30"
									imageUrl="group733"
									style={this.style_Group_7} />
								<TextView
									id={this.id("Quick_Start")}
									height="30"
									width="143"
									margin="12,1,0,0"
									weight="1"
									text={this.STR.Quick_Start50}
									textSize={FontSize.A_22}
									color={FontColor.A__FFFF0000}
									fontStyle={Font.AVENIR_HEAVY}
									gravity="left"
									style={this.style_Quick_Start} />
							</LinearLayout>
							<LinearLayout
								id={this.id("ViewcodeGithubmark")}
								height="30"
								width="155"
								orientation="horizontal"
								margin="0,30,0,0"
								style={this.style_ViewcodeGithubmark}>
								<ImageView
									id={this.id("GitHub_Mark")}
									height="30"
									width="30"
									imageUrl="githubmark34"
									style={this.style_GitHub_Mark} />
								<TextView
									id={this.id("View_Code")}
									height="30"
									width="115"
									margin="10,0,0,0"
									weight="1"
									text={this.STR.View_Code51}
									textSize={FontSize.A_22}
									color={FontColor.A__FFFF0000}
									fontStyle={Font.AVENIR_HEAVY}
									gravity="left"
									style={this.style_View_Code} />
							</LinearLayout>
						</LinearLayout>
						<LinearLayout
							id={this.id("Codebusiness")}
							height="370"
							width="820"
							orientation="vertical"
							gravity="center_horizontal"
							weight="1"
							cornerRadius="0"
							style={this.style_Codebusiness}>
							<TextView
								id={this.id("Code_business_flows")}
								height="60"
								width="match_parent"
								text={this.STR.Code_business_flows52}
								textSize={FontSize.A_20}
								color={FontColor.A__FF4A494A}
								fontStyle={Font.AVENIR_ROMAN}
								lineHeight="30px"
								gravity="left"
								style={this.style_Code_business_flows} />
							<LinearLayout
								id={this.id("WritingcodeiEverysystemi")}
								height="115"
								width="match_parent"
								orientation="horizontal"
								margin="0,50,0,0"
								style={this.style_WritingcodeiEverysystemi}>
								<LinearLayout
									id={this.id("Writingcodei")}
									height="85"
									width="360"
									orientation="vertical"
									gravity="center_horizontal"
									weight="1"
									cornerRadius="0"
									style={this.style_Writingcodei}>
									<TextView
										id={this.id("Conversational_Flow")}
										height="50"
										width="match_parent"
										text={this.STR.Conversational_Flow53}
										textSize={FontSize.A_26}
										color={FontColor.A__FF000000}
										fontStyle={Font.AVENIR_MEDIUM}
										lineHeight="42px"
										gravity="left"
										style={this.style_Conversational_Flow} />
									<TextView
										id={this.id("Writing_code_is_like")}
										height="30"
										width="match_parent"
										margin="0,5,0,0"
										text={this.STR.Writing_code_is_like54}
										textSize={FontSize.A_20}
										color={FontColor.A__FF4A494A}
										fontStyle={Font.AVENIR_ROMAN}
										lineHeight="28px"
										gravity="left"
										style={this.style_Writing_code_is_like} />
								</LinearLayout>
								<LinearLayout
									id={this.id("Everysystemi")}
									height="115"
									width="360"
									orientation="vertical"
									gravity="center_horizontal"
									margin="100,0,0,0"
									weight="1"
									cornerRadius="0"
									style={this.style_Everysystemi}>
									<TextView
										id={this.id("Building_Blocks")}
										height="50"
										width="match_parent"
										text={this.STR.Building_Blocks55}
										textSize={FontSize.A_26}
										color={FontColor.A__FF000000}
										fontStyle={Font.AVENIR_MEDIUM}
										lineHeight="42px"
										gravity="left"
										style={this.style_Building_Blocks} />
									<TextView
										id={this.id("Every_system_is_a_re")}
										height="60"
										width="match_parent"
										margin="0,5,0,0"
										text={this.STR.Every_system_is_a_re56}
										textSize={FontSize.A_20}
										color={FontColor.A__FF4A494A}
										fontStyle={Font.AVENIR_ROMAN}
										lineHeight="28px"
										gravity="left"
										style={this.style_Every_system_is_a_re} />
								</LinearLayout>
							</LinearLayout>
							<LinearLayout
								id={this.id("SystemswhichMakingdevelo")}
								height="115"
								width="match_parent"
								orientation="horizontal"
								margin="0,30,0,0"
								style={this.style_SystemswhichMakingdevelo}>
								<LinearLayout
									id={this.id("Systemswhich")}
									height="115"
									width="360"
									orientation="vertical"
									gravity="center_horizontal"
									weight="1"
									cornerRadius="0"
									style={this.style_Systemswhich}>
									<TextView
										id={this.id("Focus_on_Conversion")}
										height="50"
										width="match_parent"
										text={this.STR.Focus_on_Conversion57}
										textSize={FontSize.A_26}
										color={FontColor.A__FF000000}
										fontStyle={Font.AVENIR_MEDIUM}
										lineHeight="42px"
										gravity="left"
										style={this.style_Focus_on_Conversion} />
									<TextView
										id={this.id("Systems_which_have_i")}
										height="60"
										width="match_parent"
										margin="0,5,0,0"
										text={this.STR.Systems_which_have_i58}
										textSize={FontSize.A_20}
										color={FontColor.A__FF4A494A}
										fontStyle={Font.AVENIR_ROMAN}
										lineHeight="28px"
										gravity="left"
										style={this.style_Systems_which_have_i} />
								</LinearLayout>
								<LinearLayout
									id={this.id("Makingdevelo")}
									height="115"
									width="360"
									orientation="vertical"
									gravity="center_horizontal"
									margin="100,0,0,0"
									weight="1"
									cornerRadius="0"
									style={this.style_Makingdevelo}>
									<TextView
										id={this.id("Improved_Maintainabi")}
										height="50"
										width="match_parent"
										text={this.STR.Improved_Maintainabi59}
										textSize={FontSize.A_26}
										color={FontColor.A__FF000000}
										fontStyle={Font.AVENIR_MEDIUM}
										lineHeight="42px"
										gravity="left"
										style={this.style_Improved_Maintainabi} />
									<TextView
										id={this.id("Making_development_a")}
										height="60"
										width="match_parent"
										margin="0,5,0,0"
										text={this.STR.Making_development_a60}
										textSize={FontSize.A_20}
										color={FontColor.A__FF4A494A}
										fontStyle={Font.AVENIR_ROMAN}
										lineHeight="28px"
										gravity="left"
										style={this.style_Making_development_a} />
								</LinearLayout>
							</LinearLayout>
						</LinearLayout>
					</LinearLayout>
				</LinearLayout>
				<LinearLayout
					id={this.id("Presto_Ui")}
					height="403"
					width="match_parent"
					orientation="horizontal"
					padding="80,0,80,0"
					margin="0,100,0,0"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_Presto_Ui}>
					<LinearLayout
						id={this.id("Group_2")}
						height="204"
						width="300"
						orientation="vertical"
						cornerRadius="0"
						style={this.style_Group_2}>
						<LinearLayout
							id={this.id("Line100000000ø")}
							height="2"
							width="250"
							background={Color.A__FFD7D7D7}
							stroke="3,#ff0000"
							cornerRadius="0"
							style={this.style_Line100000000ø} />
						<TextView
							id={this.id("Presto_UI")}
							height="50"
							width="match_parent"
							margin="0,31,0,0"
							text={this.STR.Presto_UI61}
							textSize={FontSize.A_40}
							color={FontColor.A__FF000000}
							fontStyle={Font.AVENIR_BLACK}
							lineHeight="42px"
							gravity="left"
							style={this.style_Presto_UI} />
						<LinearLayout
							id={this.id("Group7Quickstarts")}
							height="31"
							width="185"
							orientation="horizontal"
							margin="0,30,0,0"
							style={this.style_Group7Quickstarts}>
							<ImageView
								id={this.id("Group_7200000000ø")}
								height="31"
								width="30"
								imageUrl="group732"
								style={this.style_Group_7200000000ø} />
							<TextView
								id={this.id("Quick_Start300000000ø")}
								height="30"
								width="143"
								margin="12,1,0,0"
								weight="1"
								text={this.STR.Quick_Start50}
								textSize={FontSize.A_22}
								color={FontColor.A__FFFF0000}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="left"
								style={this.style_Quick_Start300000000ø} />
						</LinearLayout>
						<LinearLayout
							id={this.id("ViewcodeGithubmarks")}
							height="30"
							width="155"
							orientation="horizontal"
							margin="0,30,0,0"
							style={this.style_ViewcodeGithubmarks}>
							<ImageView
								id={this.id("GitHub_Mark400000000ø")}
								height="30"
								width="30"
								imageUrl="githubmark31"
								style={this.style_GitHub_Mark400000000ø} />
							<TextView
								id={this.id("View_Code500000000ø")}
								height="30"
								width="115"
								margin="10,0,0,0"
								weight="1"
								text={this.STR.View_Code51}
								textSize={FontSize.A_22}
								color={FontColor.A__FFFF0000}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="left"
								style={this.style_View_Code500000000ø} />
						</LinearLayout>
					</LinearLayout>
					<LinearLayout
						id={this.id("Generateuico")}
						height="370"
						width="820"
						orientation="vertical"
						gravity="center_horizontal"
						margin="0,33,0,0"
						weight="1"
						cornerRadius="0"
						style={this.style_Generateuico}>
						<TextView
							id={this.id("Generate_UI_Code_dir")}
							height="60"
							width="match_parent"
							text={this.STR.Generate_UI_Code_dir62}
							textSize={FontSize.A_20}
							color={FontColor.A__FF4A494A}
							fontStyle={Font.AVENIR_ROMAN}
							lineHeight="30px"
							gravity="left"
							style={this.style_Generate_UI_Code_dir} />
						<LinearLayout
							id={this.id("FullcontrolcSinglesource")}
							height="115"
							width="match_parent"
							orientation="horizontal"
							margin="0,50,0,0"
							style={this.style_FullcontrolcSinglesource}>
							<LinearLayout
								id={this.id("Singlesource")}
								height="115"
								width="360"
								orientation="vertical"
								gravity="center_horizontal"
								weight="1"
								cornerRadius="0"
								style={this.style_Singlesource}>
								<TextView
									id={this.id("Single_Source_Code")}
									height="50"
									width="match_parent"
									text={this.STR.Single_Source_Code63}
									textSize={FontSize.A_26}
									color={FontColor.A__FF000000}
									fontStyle={Font.AVENIR_MEDIUM}
									lineHeight="42px"
									gravity="left"
									style={this.style_Single_Source_Code} />
								<TextView
									id={this.id("Design_once_and_have")}
									height="60"
									width="match_parent"
									margin="0,5,0,0"
									text={this.STR.Design_once_and_have64}
									textSize={FontSize.A_20}
									color={FontColor.A__FF4A494A}
									fontStyle={Font.AVENIR_ROMAN}
									lineHeight="28px"
									gravity="left"
									style={this.style_Design_once_and_have} />
							</LinearLayout>
							<LinearLayout
								id={this.id("FullcontrolC")}
								height="115"
								width="360"
								orientation="vertical"
								gravity="center_horizontal"
								margin="100,0,0,0"
								weight="1"
								cornerRadius="0"
								style={this.style_FullcontrolC}>
								<TextView
									id={this.id("Full_Control")}
									height="50"
									width="match_parent"
									text={this.STR.Full_Control65}
									textSize={FontSize.A_26}
									color={FontColor.A__FF000000}
									fontStyle={Font.AVENIR_MEDIUM}
									lineHeight="42px"
									gravity="left"
									style={this.style_Full_Control} />
								<TextView
									id={this.id("Change_the_UI_withou")}
									height="60"
									width="match_parent"
									margin="0,5,0,0"
									text={this.STR.Change_the_UI_withou66}
									textSize={FontSize.A_20}
									color={FontColor.A__FF4A494A}
									fontStyle={Font.AVENIR_ROMAN}
									lineHeight="28px"
									gravity="left"
									style={this.style_Change_the_UI_withou} />
							</LinearLayout>
						</LinearLayout>
						<LinearLayout
							id={this.id("QuickdevelopSyntaxinspir")}
							height="115"
							width="match_parent"
							orientation="horizontal"
							margin="0,30,0,0"
							style={this.style_QuickdevelopSyntaxinspir}>
							<LinearLayout
								id={this.id("SyntaxInspir")}
								height="115"
								width="360"
								orientation="vertical"
								gravity="center_horizontal"
								weight="1"
								cornerRadius="0"
								style={this.style_SyntaxInspir}>
								<TextView
									id={this.id("Syntax")}
									height="50"
									width="match_parent"
									text={this.STR.Syntax67}
									textSize={FontSize.A_26}
									color={FontColor.A__FF000000}
									fontStyle={Font.AVENIR_MEDIUM}
									lineHeight="42px"
									gravity="left"
									style={this.style_Syntax} />
								<TextView
									id={this.id("Inspired_by_Android")}
									height="60"
									width="match_parent"
									margin="0,5,0,0"
									text={this.STR.Inspired_by_Android68}
									textSize={FontSize.A_20}
									color={FontColor.A__FF4A494A}
									fontStyle={Font.AVENIR_ROMAN}
									lineHeight="28px"
									gravity="left"
									style={this.style_Inspired_by_Android} />
							</LinearLayout>
							<LinearLayout
								id={this.id("Quickdevelop")}
								height="115"
								width="360"
								orientation="vertical"
								gravity="center_horizontal"
								margin="100,0,0,0"
								weight="1"
								cornerRadius="0"
								style={this.style_Quickdevelop}>
								<TextView
									id={this.id("Quick_Development")}
									height="50"
									width="match_parent"
									text={this.STR.Quick_Development69}
									textSize={FontSize.A_26}
									color={FontColor.A__FF000000}
									fontStyle={Font.AVENIR_MEDIUM}
									lineHeight="42px"
									gravity="left"
									style={this.style_Quick_Development} />
								<TextView
									id={this.id("Auto_generate_UI_cod")}
									height="60"
									width="match_parent"
									margin="0,5,0,0"
									text={this.STR.Auto_generate_UI_cod70}
									textSize={FontSize.A_20}
									color={FontColor.A__FF4A494A}
									fontStyle={Font.AVENIR_ROMAN}
									lineHeight="28px"
									gravity="left"
									style={this.style_Auto_generate_UI_cod} />
							</LinearLayout>
						</LinearLayout>
					</LinearLayout>
				</LinearLayout>
				<LinearLayout
					id={this.id("Subscribe")}
					height="262"
					width="match_parent"
					orientation="vertical"
					gravity="center_horizontal"
					margin="0,100,0,0"
					padding="80,0,80,0"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_Subscribe}>
					<LinearLayout
						id={this.id("Line_2")}
						height="2"
						width="match_parent"
						background={Color.A__FFD7D7D7}
						stroke="3,#ff0000"
						cornerRadius="0"
						style={this.style_Line_2} />
					<LinearLayout
						id={this.id("Group_3")}
						height="142"
						width="416"
						orientation="horizontal"
						gravity="center"
						margin="0,38,0,0"
						style={this.style_Group_3}>
						<LinearLayout
							id={this.id("Group_4")}
							height="match_parent"
							width="match_parent"
							orientation="vertical"
							style={this.style_Group_4}>
							<TextView
								id={this.id("Get_the_latest_Prest")}
								height="25"
								width="match_parent"
								text={this.STR.Get_the_latest_Prest71}
								textSize={FontSize.A_18}
								color={FontColor.A__FF4A494A}
								fontStyle={Font.AVENIR_ROMAN}
								gravity="left"
								style={this.style_Get_the_latest_Prest} />
							<LinearLayout
								id={this.id("Group")}
								height="36"
								width="350"
								orientation="vertical"
								margin="0,31,0,0"
								style={this.style_Group}>
								<LinearLayout
									id={this.id("YouremailaddressNoun_1358889_cc")}
									height="25"
									width="match_parent"
									orientation="horizontal"
									style={this.style_YouremailaddressNoun_1358889_cc}>
									<ImageView
										id={this.id("Noun_1358889_cc")}
										height="20"
										width="34"
										margin="0,4,0,0"
										imageUrl="noun_1358889_cc30"
										style={this.style_Noun_1358889_cc} />
									<EditText
										id={this.id("Your_email_address")}
										height="25"
										width="297"
										margin="18,0,0,0"
										weight="1"
										textSize={FontSize.A_18}
										color={FontColor.A__FF000000}
										fontStyle={Font.AVENIR_ROMAN}
										gravity="left"
										hint={this.STR.Your_email_address72}
										background="#ffffff"
										padding="0,0,0,0"
										style={this.style_Your_email_address} />
								</LinearLayout>
								<LinearLayout
									id={this.id("Line_3")}
									height="2"
									width="match_parent"
									background={Color.A__FFD7D7D7}
									stroke="1,#ff0000"
									margin="0,9,0,0"
									cornerRadius="0"
									style={this.style_Line_3} />
							</LinearLayout>
							<TextView
								id={this.id("Subscribe600000000ø")}
								height="30"
								width="101"
								margin="0,20,0,0"
								text={this.STR.Subscribe73}
								textSize={FontSize.A_22}
								color={FontColor.A__FFFF0000}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="left"
								style={this.style_Subscribe600000000ø} />
						</LinearLayout>
					</LinearLayout>
					<LinearLayout
						id={this.id("Rectangle")}
						height="63"
						width="match_parent"
						background={Color.A__FFFFFFFF}
						margin="0,17,0,0"
						cornerRadius="0"
						style={this.style_Rectangle} />
				</LinearLayout>
			</LinearLayout>
		);
		this.containerId = this.layout.idSet.id;
		return this.layout.render();
	}

};

module.exports = Presto;



// WEBPACK FOOTER //
// ./views/Main/Presto.js